import { createApp } from 'vue';
import { createPinia } from 'pinia';
import AltoneoUI from 'altoneo-charting';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './assets/main.css';

import App from './App.vue';
import { router } from './router';
import { initPreferences } from './lib/preferences';
import { initInstallation } from './lib/installation';

// Applique thème (clair/sombre/système) et contraste AVANT le montage : pas de
// clignotement au chargement.
initPreferences();

// AVANT LE MONTAGE aussi, mais pour une autre raison : Chrome émet son
// invitation à installer très tôt, et il ne la rejoue pas. Une écoute posée au
// montage d'un composant l'aurait manquée un chargement sur deux.
initInstallation();

createApp(App).use(createPinia()).use(router).use(AltoneoUI).mount('#app');
